import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chroma-container" }
const _hoisted_2 = { class: "photo-picker" }
const _hoisted_3 = { class: "palette-fill" }
const _hoisted_4 = { class: "reminder" }
const _hoisted_5 = { class: "preview-row" }
const _hoisted_6 = { class: "btn-wrap" }
const _hoisted_7 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_image_not_uploaded = _resolveComponent("app-image-not-uploaded")!
  const _component_app_image_color_picker = _resolveComponent("app-image-color-picker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_palette_fill_card = _resolveComponent("app-palette-fill-card")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["chroma-wrapper", { hiddenOverflow: _ctx.isHiddenOverflow }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.imgEl)
          ? (_openBlock(), _createBlock(_component_app_image_not_uploaded, {
              key: 0,
              onOnFileSelected: _ctx.onFileSelected
            }, null, 8, ["onOnFileSelected"]))
          : _createCommentVNode("", true),
        (_ctx.imgEl)
          ? (_openBlock(), _createBlock(_component_app_image_color_picker, {
              key: 1,
              ref: "imageColorPickerRef",
              "image-element": _ctx.imgEl,
              "is-show-section-info": false,
              onSelectedHex: _ctx.onSelectedHex,
              onIsHiddenOverflow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHiddenOverflow = $event)),
              onImageUrlChanged: _ctx.imageUrlChange
            }, null, 8, ["image-element", "onSelectedHex", "onImageUrlChanged"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            size: "xl",
            icon: ['fas', 'exclamation-triangle']
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('reminderPickColor')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paletteCards, (item) => {
            return (_openBlock(), _createBlock(_component_app_palette_fill_card, {
              key: item.id,
              "selected-hex": item,
              "is-selected": _ctx.selectedCard?.id === item?.id,
              onSelected: _ctx.onSelectedCard
            }, null, 8, ["selected-hex", "is-selected", "onSelected"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_app_button, {
              title: "define",
              onClick: _ctx.range
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ], 2)
  ]))
}